import React from 'react';
import Matt from '../../images/matt.jpg';
import Ralph from '../../images/ralph.jpg';
import Adela from '../../images/adela.jpg';
import James from '../../images/james.jpg';
import JoeL from '../../images/josephl.jpg';
import JoeT from '../../images/josepht.jpg';
import Polly from '../../images/polly.jpg';
import William from '../../images/william.jpg';
import Nichole from '../../images/nichole.png';
import Nithin from '../../images/nithin.jpg';
import Ernest from '../../images/ernest.jpg';
import Tony from '../../images/tony.jpg';


import { Card, Container, Divider, Header, Image, Modal } from 'semantic-ui-react';


import './style.css';

class Experts extends React.Component {
  state = {
    width:0,
    height:0
  }
  constructor(props) {
    super(props);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return (<div className="Staff">
    <Container text textAlign='left'>
      <Header as='h3' textAlign='center'>
        Council of Experts
      </Header>
      <p>
        To expand OVC’s science and innovation expertise and to offer such expertise to the
        portfolio companies, OVC has organized a unique group of experts consisting of
        renowned practitioners in medical science, bioscience, computer science, law, and
        finance. These individuals have achieved high-level education and professional
        experience. They interact with the key managers at the portfolio companies. They
        are the connectors who provide science and financial advice to the portfolio
        startups to achieve product commercialization and positive market results.
      </p>
    </Container>
    <Divider/>

      { this.state.width < 768 ?
        <Card.Group itemsPerRow={1} centered  >
        <Modal size='small' trigger={
          <Card color='blue'>
          <Image src={Matt} wrapped ui={false} />
          <Card.Content>
          <Card.Header>Dr. Matthew Daniels</Card.Header>
          <Card.Description>
          Medicine & Bioscience
          </Card.Description>
          </Card.Content>
          </Card>
        }>
        <Modal.Header>Dr. Matthew Daniels, Chairman</Modal.Header>
        <Modal.Content scrolling >
        <Modal.Description>
        <Header>
        BSc (Nottm), MA. MB, BChir, PhD (Cantab), MRCP FSCAI, Consultant Physician (Cardiology)
        
        </Header>
        <p className="Card__Text__Body">
          Senior Lecturer University of Manchester-division of cardiovascular medicine & division of cell matrix biology & regenerative medicine. Honorary Consultant Cardiologist, University of Manchester NHS Foundation Trust. 
          Lead for Clinical research at the Manchester Heart Centre.
        <br/>
          Formerly Academic Consultant Cardiologist and principal investigator; a cardio-vascular and bioimaging expert, 
          with clinical practice in structural and inherited heart disease (Oxford University Hospital). Led research program 
          (Oxford University BHF Centre of Research Excellence and Osaka University) investigating real-time visualization of 
          intracellular signaling in the context of inherited cardiomyopathy, diabetes, and stem-cell derivatives that 
          might be used in cardiac regeneration, by high-content advanced light microscopy. Fellow of the Society of Cardiac 
          Angiography and Interventions (Congenital council structural heart sub-committee). Member of the Royal College of Physicians, 
          the Association of Inherited Cardiac Conditions, the British Cardiac Society (Program Committee), 
          and the Genomics England Clinical Interpretation Panel (Cardiovascular sub-domain).
        </p>
        </Modal.Description>
        </Modal.Content>
        </Modal>

          <Modal size='small' trigger={
            <Card color='blue'>
            <Image src={JoeT} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Dr. Joseph Wing-On Tam</Card.Header>
            <Card.Description>
            Genetics & Molecular Diagnostics
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Dr. Joseph Wing-On Tam, Vice Chairman</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          PhD Chemistry (UC Davis), Postdoctoral (Northwestern)
          </Header>
          <p className="Card__Text__Body">
          Research pioneer with over 30 years of teaching and research experience in the biotechnology and diagnostics sector.
          Honorary Professor of the School of Biomedical Science and Retired Professor of Biochemistry at Li Ka Shing Faculty of Medicine, The
          University of Hong Kong. Founder, Retired CEO and Chairman, DiagCor Bioscience and Pangenia, Hong Kong.  Founder and President of the Hong Kong
          Biochemistry Association.  Visiting Professor at UCSF, Baylor Medical College, and Medical College of Georgia; Scientist of National Institute of Health.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='small' trigger={
            <Card color='blue'>
            <Image src={Ralph} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Ralph Baber</Card.Header>
            <Card.Description>
            Investment & Finance
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Ralph Baber</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          BSc (Hons, Manchester), Chartered Accountant
          </Header>
          <p className="Card__Text__Body">
          COO, Slater Investments, London.  Formerly COO, WorldInvest, London.  Managing substantial
          equity investment portfolios for public and private clients.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='small' trigger={
            <Card color='blue'>
            <Image src={Adela} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Adela Cepeda</Card.Header>
            <Card.Description>
            Minority Business Enterprise
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Adela Cepeda </Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          MBA (Chicago), BA-Honors (Harvard)
          </Header>
          <p className="Card__Text__Body">
          Private investor and cofounder of the Angeles LatinX Venture Fund.  
          Serves on boards of UBS Funds, Pathway Mutual Funds and chairs Mercer Mutual Funds.  
          Director of BMO Financial Corp., the US holding company for BMO Harris Bank.  Chair of BMO’s Capital Committee.  
          Formerly managing director of PFM, the top ranked municipal advisor in the US.  
          Founder of A.C. Advisory which was sold to PFM.
          <br/>
          Serves on not-for-profit Cook County Council of Economic Advisors and City of Chicago Community Development 
          Commission and boards of Chicago Foundation for Women, Arrupe College of Loyola University Chicago, Rush University, and Teatro Vista.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>
          
          <Modal size='small' trigger={
            <Card color='blue'>
            <Image src={Polly} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Dr. Polly Wai-In Chan</Card.Header>
            <Card.Description>
            Bioscience & Marketing
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Dr. Polly Wai-In Chan</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          PhD Genetics (Nottm), BSc Cell Biology and Genetics (Peking)
          </Header>
          <p className="Card__Text__Body">
          Marketing research at Amano Enzyme Inc., Japan. Formerly Assistant Professor,
          Macau University of Science and Technology.
          Research Associate at Cambridge University and at Wellcome Trust Sanger Institute.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={William} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Dr. William Cheung</Card.Header>
            <Card.Description>
            Clinical Validation Studies
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Dr. William Cheung</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          Postdoctoral (Yale University School of Medicine), PhD Cancer Biology
          (HKU), BSc Bioinformatics
          </Header>
          <p className="Card__Text__Body">
          Founder and director, Action Life Sciences Consulting, Hong Kong. Formerly senior
          scientist at DiagCor Bioscience who led team members in cancer diagnostics, clinical
          validation studies, bioinformatics infrastructure for analysis of large-scale genomic data and
          provided scientific support to sales and marketing team.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={Nichole} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Nichole Garcia</Card.Header>
            <Card.Description>
            Medical Venture Investments
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Nichole Garcia</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          DFS - Distinction (Oxford), MBA (Pepperdine), BSc Biochemistry (UCLA)
          </Header>
          <p className="Card__Text__Body">
          A C-Suite global leader, Nichole is Managing Director, Silicon Valley Capital, a seed-stage
          and early-stage venture capital fund. It invests in entrepreneurial teams seeking to
          transform big ideas into game-changing companies. Co-founder of Smylio Inc., a disruptive
          medical device and software company. Member of Young Presidents’ Organization (YPO).
          Active sponsor of Orange Babies Foundation and American Heart Association. Former
          GM/CEO of Philips Oral HealthCare Division.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='small' trigger={
            <Card color='blue'>
            <Image src={James} wrapped ui={false} />
            <Card.Content>
            <Card.Header>James Hao</Card.Header>
            <Card.Description>
            Patent Law
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>James Hao</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          JD (Louisville), BSEE (Tennessee), MSEE (Southern Methodist)
          </Header>
          <p className="Card__Text__Body">
          Patent Law / Attorney Partner, Murabito, Hao & Barnes, San Jose, CA.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={Nithin} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Nithin Johnson</Card.Header>
            <Card.Description>
            Valuation/Capital Transactions
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Nithin Johnson</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          MBA (Oxford), BA Economics (Ohio State)
          </Header>
          <p className="Card__Text__Body">
          Executive Director, Tikehau Capital. Director, Arcbridge Capital (Family Office). Formerly
          Head of International Fund Distribution (IFD), Citigroup; IFD originates differentiated private
          investment strategies sourced for the benefit of Citi’s pension, insurance, endowment, foundation, wealth manager, and other institutional clients. Since 2000, Citi has a track
          record of raising over $70 billion of LP commitments. IFD works with exceptional fund
          managers across various private equity and debt markets.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='small' trigger={
            <Card color='blue'>
            <Image src={JoeL} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Joseph Lin</Card.Header>
            <Card.Description>
            Business Law in Bioscience & Technology
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Joseph Lin</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          JD (UCLA), BSc Engineering - Distinction (Cornell)
          </Header>
          <p className="Card__Text__Body">
          General Counsel, Triple Ring Technologies, Newark, CA.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='small' trigger={
            <Card color='blue'>
            <Image src={Ernest} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Ernest Y.K. Wong</Card.Header>
            <Card.Description>
            Investment Banking, IPOs/HKEx
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Ernest Y.K. Wong</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          MSc Major Programme Management (Oxford), MSc Investment
          Management (HKUST), MSc Electronic Engineering (CUHK), BBA (HKU).
          Chartered Financial Analyst
          </Header>
          <p className="Card__Text__Body">
          President and Group CFO of KVB Holdings Limited and CFO and Company Secretary of its
          listed subsidiary, KVB Kunlun Financial Group Limited.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='small' trigger={
            <Card color='blue'>
            <Image src={Tony} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Tony Kam Fai Yung</Card.Header>
            <Card.Description>
            Molecular Diagnostics, Med Tech
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Tony Kam Fai Yung</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          MSc Bioscience (CUHK)
          </Header>
          <p className="Card__Text__Body">
          Biotechnology practitioner and entrepreneur in Hong Kong.  
          CEO of Take2 Health Ltd.  Formerly, General Manager of Xcelom, a family care biotechnology company 
          in the Hong Kong Science Park and Managing Director of Asia Business and Market Development at GRAIL, Inc., 
          a US-based biotechnology company.  Co-founder and former CEO of Sanomics, a cancer management company.  
          Co-founder and director of Oxford Venture Capital (Greater China) Limited.  
          Director of Luxagain Technology Limited, and Fellow of the Hong Kong College of Health Service Executives.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>


          </Card.Group>

        :
        <Card.Group itemsPerRow={4} centered >
        <Modal size='large' trigger={
          <Card color='blue'>
          <Image src={Matt} wrapped ui={false} />
          <Card.Content>
          <Card.Header>Dr. Matthew Daniels</Card.Header>
          <Card.Description>
          Medicine & Bioscience
          </Card.Description>
          </Card.Content>
          </Card>
        }>
        <Modal.Header>Dr. Matthew Daniels, Chairman</Modal.Header>
        <Modal.Content scrolling >
        <Modal.Description>
        <Header>
        BSc (Nottm), MA. MB, BChir, PhD (Cantab), MRCP FSCAI, Consultant Physician (Cardiology)
        </Header>
        <p className="Card__Text__Body">
          Senior Lecturer University of Manchester-division of cardiovascular medicine & division of cell matrix biology & regenerative medicine. Honorary Consultant Cardiologist, University of Manchester NHS Foundation Trust. 
          Lead for Clinical research at the Manchester Heart Centre.
        <br/>
          Formerly Academic Consultant Cardiologist and principal investigator; a cardio-vascular and bioimaging expert, 
          with clinical practice in structural and inherited heart disease (Oxford University Hospital). Led research program 
          (Oxford University BHF Centre of Research Excellence and Osaka University) investigating real-time visualization of 
          intracellular signaling in the context of inherited cardiomyopathy, diabetes, and stem-cell derivatives that 
          might be used in cardiac regeneration, by high-content advanced light microscopy. Fellow of the Society of Cardiac 
          Angiography and Interventions (Congenital council structural heart sub-committee). Member of the Royal College of Physicians, 
          the Association of Inherited Cardiac Conditions, the British Cardiac Society (Program Committee), 
          and the Genomics England Clinical Interpretation Panel (Cardiovascular sub-domain).
        </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={JoeT} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Dr. Joseph Wing-On Tam</Card.Header>
            <Card.Description>
            Genetics & Molecular Diagnostics
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Dr. Joseph Wing-On Tam, Vice Chairman</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          PhD Chemistry (UC Davis), Postdoctoral (Northwestern)
          </Header>
          <p className="Card__Text__Body">
          Research pioneer with over 30 years of teaching and research experience in the biotechnology and diagnostics sector.
          Honorary Professor of the School of Biomedical Science and Retired Professor of Biochemistry at Li Ka Shing Faculty of Medicine, The
          University of Hong Kong. Founder, Retired CEO and Chairman, DiagCor Bioscience and Pangenia, Hong Kong.  Founder and President of the Hong Kong
          Biochemistry Association.  Visiting Professor at UCSF, Baylor Medical College, and Medical College of Georgia; Scientist of National Institute of Health.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={Ralph} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Ralph Baber</Card.Header>
            <Card.Description>
            Investment & Finance
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Ralph Baber</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          BSc (Hons, Manchester), Chartered Accountant
          </Header>
          <p className="Card__Text__Body">
          COO, Slater Investments, London.  Formerly COO, WorldInvest, London.  Managing substantial
          equity investment portfolios for public and private clients.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={Adela} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Adela Cepeda</Card.Header>
            <Card.Description>
            Minority Business Enterprise
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Adela Cepeda </Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          MBA (Chicago), BA-Honors (Harvard)
          </Header>
          <p className="Card__Text__Body">
          Private investor and cofounder of the Angeles LatinX Venture Fund.  
          Serves on boards of UBS Funds, Pathway Mutual Funds and chairs Mercer Mutual Funds.  
          Director of BMO Financial Corp., the US holding company for BMO Harris Bank.  Chair of BMO’s Capital Committee.  
          Formerly managing director of PFM, the top ranked municipal advisor in the US.  
          Founder of A.C. Advisory which was sold to PFM.
          <br/>
          Serves on not-for-profit Cook County Council of Economic Advisors and City of Chicago Community Development 
          Commission and boards of Chicago Foundation for Women, Arrupe College of Loyola University Chicago, Rush University, and Teatro Vista.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={Polly} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Dr. Polly Wai-In Chan</Card.Header>
            <Card.Description>
            Bioscience & Marketing
            </Card.Description>
            </Card.Content>
            </Card>
          }>
            <Modal.Header>Dr. Polly Wai-In Chan</Modal.Header>
            <Modal.Content scrolling >
              <Modal.Description>
                <Header>
                  PhD Genetics (Nottm), BSc Cell Biology and Genetics (Peking)
                </Header>
                <p className="Card__Text__Body">
                Marketing research at Amano Enzyme Inc., Japan. Formerly Assistant Professor,
                Macau University of Science and Technology.
                Research Associate at Cambridge University and at Wellcome Trust Sanger Institute.
                </p>
              </Modal.Description>
            </Modal.Content>
          </Modal>




          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={William} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Dr. William Cheung</Card.Header>
            <Card.Description>
            Clinical Validation Studies
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Dr. William Cheung</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          Postdoctoral (Yale University School of Medicine), PhD Cancer Biology
          (HKU), BSc Bioinformatics
          </Header>
          <p className="Card__Text__Body">
          Founder and director, Action Life Sciences Consulting, Hong Kong. Formerly senior
          scientist at DiagCor Bioscience who led team members in cancer diagnostics, clinical
          validation studies, bioinformatics infrastructure for analysis of large-scale genomic data and
          provided scientific support to sales and marketing team.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={Nichole} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Nichole Garcia</Card.Header>
            <Card.Description>
            Medical Venture Investments
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Nichole Garcia</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          DFS - Distinction (Oxford), MBA (Pepperdine), BSc Biochemistry (UCLA)
          </Header>
          <p className="Card__Text__Body">
          A C-Suite global leader, Nichole is Managing Director, Silicon Valley Capital, a seed-stage
          and early-stage venture capital fund. It invests in entrepreneurial teams seeking to
          transform big ideas into game-changing companies. Co-founder of Smylio Inc., a disruptive
          medical device and software company. Member of Young Presidents’ Organization (YPO).
          Active sponsor of Orange Babies Foundation and American Heart Association. Former
          GM/CEO of Philips Oral HealthCare Division.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={James} wrapped ui={false} />
            <Card.Content>
            <Card.Header>James Hao</Card.Header>
            <Card.Description>
            Patent Law
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>James Hao</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          JD (Louisville), BSEE (Tennessee), MSEE (Southern Methodist)
          </Header>
          <p className="Card__Text__Body">
          Patent Law / Attorney Partner, Murabito, Hao & Barnes, San Jose, CA.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={Nithin} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Nithin Johnson</Card.Header>
            <Card.Description>
            Valuation/Capital Transactions
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Nithin Johnson</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          MBA (Oxford), BA Economics (Ohio State)
          </Header>
          <p className="Card__Text__Body">
          Executive Director, Tikehau Capital. Director, Arcbridge Capital (Family Office). Formerly
          Head of International Fund Distribution (IFD), Citigroup; IFD originates differentiated private
          investment strategies sourced for the benefit of Citi’s pension, insurance, endowment, foundation, wealth manager, and other institutional clients. Since 2000, Citi has a track
          record of raising over $70 billion of LP commitments. IFD works with exceptional fund
          managers across various private equity and debt markets.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={JoeL} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Joseph Lin</Card.Header>
            <Card.Description>
            Business Law in Bioscience & Technology
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Joseph Lin</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          JD (UCLA), BSc Engineering - Distinction (Cornell)
          </Header>
          <p className="Card__Text__Body">
          General Counsel, Triple Ring Technologies, Newark, CA.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='large' trigger={
            <Card color='blue'>
            <Image src={Ernest} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Ernest Y.K. Wong</Card.Header>
            <Card.Description>
            Investment Banking, IPOs/HKEx
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Ernest Y.K. Wong</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          MSc Major Programme Management (Oxford), MSc Investment
          Management (HKUST), MSc Electronic Engineering (CUHK), BBA (HKU).
          Chartered Financial Analyst
          </Header>
          <p className="Card__Text__Body">
          President and Group CFO of KVB Holdings Limited and CFO and Company Secretary of its
          listed subsidiary, KVB Kunlun Financial Group Limited.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          <Modal size='small' trigger={
            <Card color='blue'>
            <Image src={Tony} wrapped ui={false} />
            <Card.Content>
            <Card.Header>Tony Kam Fai Yung</Card.Header>
            <Card.Description>
            Molecular Diagnostics, Med Tech
            </Card.Description>
            </Card.Content>
            </Card>
          }>
          <Modal.Header>Tony Kam Fai Yung</Modal.Header>
          <Modal.Content scrolling >
          <Modal.Description>
          <Header>
          MSc Bioscience (CUHK)
          </Header>
          <p className="Card__Text__Body">
          Biotechnology practitioner and entrepreneur in Hong Kong.  
          CEO of Take2 Health Ltd.  Formerly, General Manager of Xcelom, a family care biotechnology company 
          in the Hong Kong Science Park and Managing Director of Asia Business and Market Development at GRAIL, Inc., 
          a US-based biotechnology company.  Co-founder and former CEO of Sanomics, a cancer management company.  
          Co-founder and director of Oxford Venture Capital (Greater China) Limited.  
          Director of Luxagain Technology Limited, and Fellow of the Hong Kong College of Health Service Executives.
          </p>
          </Modal.Description>
          </Modal.Content>
          </Modal>

          </Card.Group>
      }

      <Divider/>

    </div>);
  }
}

export default Experts;
